export const transactionCustomerColumns = [
  { key: 'customerAccountNumber', text: 'Account Number', width: '15%' },
  { key: 'firstName', text: 'First Name', width: '15%' },
  { key: 'lastName', text: 'Last Name', width: '15%' },
  // { key: 'productType', text: 'Product Type', width: '15%' },
  { key: 'amount', text: 'Amount', width: '20%' }
];
